import React from "react";
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function changeLanguage_main_section(allession_data,timeSlotName){
     
  let languageCode_local = parseInt(localStorage.getItem('default_langage_code'));
    let return_value=false;
    let r_data;
      for(let y = 0; y < allession_data.sectionHtmlModuleLanguages.length; y++){
        
        if(allession_data.sectionHtmlModuleLanguages[y].languageDetails.languageId == languageCode_local  && allession_data.sectionHtmlModuleLanguages[y][timeSlotName] != null){
       return_value=true;
       r_data = allession_data.sectionHtmlModuleLanguages[y][timeSlotName];
       break;
        }else{
          r_data = allession_data[timeSlotName];
        }
        
      }

      if(!return_value){
     r_data = allession_data[timeSlotName];
      }

      return r_data;
}
const PdfModal = ({triggerGrandchildRefresh}) => {
    const { t, i18n } = useTranslation();
    const default_value = {
        start_time:'10:00 AM',
        end_time:'10:00 AM',
        title:'Hour One',
    };

    const default_description = {
        title:null,
        type:'Facilitator',
        timeSlotdetails:null,
        info1:[],
        info2:[],
        duration:'10 Minutes',
        description:null,
    };
    const [item, setItem] = useState(default_value);
    const [detailes, setdetailes] = useState(default_description);
    const [htmld, sethtmldt] = useState([]);

      useEffect(() => {
    const storedItem = JSON.parse(sessionStorage.getItem('fac_item_data'));
    if (storedItem) setItem(storedItem);
    const storeddetails = JSON.parse(sessionStorage.getItem('fac_item_desctiption'));
    console.log(storeddetails);
        let myhtmld = [];
        if(storeddetails && storeddetails.info1.length !== 0){
    for(let y = 0; y < storeddetails.info1.length; y++){
        console.log(storeddetails.info1[y]);
      let html_dcon =  changeLanguage_main_section(storeddetails.info1[y],'htmlContentInfo1');
       myhtmld.push(html_dcon);
    }
    if(sethtmldt) sethtmldt(myhtmld)}
    if (storeddetails) setdetailes(storeddetails);
  }, [triggerGrandchildRefresh]);


  return (  
    <div className="modal video-show-modal facilatator-modal fade" id="facilatatorModal"  aria-labelledby="facilatatorModalLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            <span>{detailes.type}</span>
           {detailes.title}
          </h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
            <div className="slider-container">
                <div className="all-video-slider">
                    <div className="slide">
                        <div className="facilatator-slider-wrapper d-flex align-items-center">
                            <div className="left-content">
                                <div className="seminar-header">
                                    <h2># {t('one2one_seminar')}</h2>
                                    <h3>[{item.start_time} - {item.end_time}]</h3>
                                </div>
                                <div className="seminar-hour-title">
                                    <h2>{item.title}</h2>
                                </div>
                                <div className="seminar-length d-flex align-items-center">
                                    <div className="seminar-type">
                                        <p>{detailes.type}</p>
                                    </div>
                                    <div className="length-clock">
                                        <p className="d-flex align-items-center"><span><img src="asset/img/clock-white.svg" alt=""/></span>{detailes.duration}</p>
                                    </div>
                                </div>
                                
                                <div className="seminar-detailes-content" dangerouslySetInnerHTML={{ __html: htmld[0] }}>
                                
                                </div>

                            </div>
                            <div className="right-content">
                                <div className="manual-heading">
                                    <h3>{t("Facilitator_Manual")}</h3>
                                    <ul>
                                        <div className="manual-content" dangerouslySetInnerHTML={{ __html: htmld[1] }}>
                                        </div>

                                        
                                    </ul>
                                    <div className="manual-content" dangerouslySetInnerHTML={{ __html: htmld[2] }}>
                                        </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    
              </div>
            </div> 
        </div>
      </div>
    </div>
  </div>
  );
};

export default PdfModal;